import { styled } from 'styled-components';

import { StyledVersionedRouterLink } from '#/components/Link/StyledVersionedRouterLink';
import { colors, cssBreakpoints } from '#/theme/theme';

export const Link = styled(StyledVersionedRouterLink)`
  letter-spacing: 0.44px;

  &:hover {
    text-decoration: none;
  }
`;

export const ResultsCount = styled.div`
  padding: 0 10px;
  margin: 0 10px;
  border: 1px solid ${colors.elementGrey};
  border-width: 0 1px;
  color: ${colors.lightContentGrey};
`;

export const SearchContextHeader_Hide_1 = styled.div`
  display: block;

  @media all and (min-width: ${cssBreakpoints.smUp}) {
    display: none;
  }
`;

export const SearchContextHeader_Hide_2 = styled.div`
  display: none;

  @media all and (min-width: ${cssBreakpoints.smUp}) {
    display: block;
  }
`;
